<template>
  <el-row class="m-b-1">
    <el-col :span="8">
      <h6>Shipping</h6>
    </el-col>
    <el-col :span="12">
      <el-select v-model="selectedId"
                 placeholder="Select"
                 size="mini">
        <el-option v-for="shippingRate in options"
                   v-show="!isDisabled(shippingRate)"
                   :value="shippingRate.id"
                   :key="shippingRate.id"
                   :label="shippingRate.name"/>
      </el-select>
    </el-col>
    <el-col :span="4" class="text-right">
      <div :class="selectedId === 0 ? 'cross-out' : ''">
        <PriceDisplay
            :originalPrice="Number(selected.price)"
            :updatePrice="Number(selected.price)"
        />
      </div>
    </el-col>
    <template v-if="selectedId === 0">
      <el-col :span="12" :offset="8">
        <el-select v-model="customSelectedId"
                   placeholder="Select"
                   size="mini">
          <el-option v-for="shippingRate in customOptions"
                     v-show="!isDisabled(shippingRate)"
                     :value="shippingRate.id"
                     :key="shippingRate.id"
                     :label="shippingRate.name"/>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-input v-model="customSelectedPrice"
                  v-mask="shippingPriceMask"
                  type="text"
                  class="el-input--underline el-input--underline-right pull-right"
                  :class="{'el-input-border--danger': !$v.shipping.customPrice.maxValue}"
                  size="mini">
          <span v-text="customSelectedPrice"></span>
        </el-input>
        <div v-if="!$v.shipping.customPrice.maxValue" class="text-danger">
          Shipping price cannot be more than <strong>${{ shippingPrice }}</strong>
        </div>
      </el-col>
    </template>
  </el-row>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {mask} from '../../../../directives';
import {
  ORDER_SHIPPING_SELECT,
  ORDER_SHIPPING_CUSTOM_SELECT,
  ORDER_SET_SHIPPING_CUSTOM_SELECTED_PRICE,
} from '../../../../store/types';
import PriceDisplay from '../../Shared/PriceDisplay';

export default {
  name: 'OrderShipping',
  components: {PriceDisplay},
  inject: ['$v'],
  directives: {
    mask,
  },
  computed: {
    ...mapState({
      options: state => state.order.shipping.options,
      selected: state => state.order.shipping.selected,
      customOptions: state => state.order.shipping.customOptions,
      customSelected: state => state.order.shipping.customSelected,
      customPrice: state => state.order.shipping.customPrice,
      subtotalPrice: state => state.order.payment.subtotalPrice,
      shippingPrice: state => {
        if (state.order.order.shipping_lines.length > 0) {
          return state.order.order.shipping_lines[0].price;
        }
        return 0;
      },
    }),
    selectedId: {
      set(selected) {
        this.setSelected(selected);
        this.$v.shipping.$touch();
      },
      get() {
        return this.selected.id;
      },
    },
    customSelectedId: {
      set(selected) {
        this.setCustomSelected(selected);
        this.$v.shipping.$touch();
      },
      get() {
        return this.customSelected.id;
      },
    },
    customSelectedPrice: {
      set(price) {
        this.setCustomSelectedPrice(price);
        this.$v.shipping.$touch();
      },
      get() {
        return this.customPrice;
      },
    },
  },
  methods: {
    ...mapActions({
      setSelected: ORDER_SHIPPING_SELECT,
      setCustomSelected: ORDER_SHIPPING_CUSTOM_SELECT,
    }),
    ...mapMutations({
      setCustomSelectedPrice: ORDER_SET_SHIPPING_CUSTOM_SELECTED_PRICE,
    }),
    isDisabled: function(shippingRate) {
      const currentShippingPrice = Number(this.shippingPrice);
      const shippingRatePrice = Number(shippingRate.price);
      const orderCost = Number(this.subtotalPrice);
      const minOrderSubtotal = shippingRate.min_order_subtotal !== null
          ? Number(shippingRate.min_order_subtotal)
          : null;

      // Always allow Custom Shipping Line
      if (shippingRate.id === 0) {
        return false;
      }

      // Only allow options that are cheaper than the current option
      if (currentShippingPrice < shippingRatePrice) {
        return true;
      }

      // Do not allow shipping line if min order is not met
      if (minOrderSubtotal && (orderCost < minOrderSubtotal)) {
        // Force custom shipping line since Shopify will not allow you to add
        // a shipping line if the criteria is not met for that shipping line
        return true;
      }

      return false;
    },
  },
  data() {
    return {
      shippingPriceMask: {
        alias: 'currency',
        prefix: '$',
        rightAlign: false,
        showMaskOnHover: false,
        autoUnmask: true,
        clearIncomplete: true,
      },
    };
  },
};
</script>

